<template>
  <svg id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path
        d="m482 25h-452c-16.542 0-30 13.458-30 30v298c0 16.542 13.458 30 30 30h147v74h-81c-8.284 0-15 6.716-15 15s6.716 15 15 15h320c8.284 0 15-6.716 15-15s-6.716-15-15-15h-81v-74h147c16.542 0 30-13.458 30-30v-298c0-16.542-13.458-30-30-30zm-177 432h-98v-74h98zm177-104c-13.157 0-441.456 0-452 0v-298h452c.019 304.472.1 298 0 298z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'monitor',
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
